import type { SubscriptionCancelStore } from '@stores/subscription-cancel/interfaces'

import { KeepLearningReason } from '@brighterly/lib-core-types/subscription/enums'

export const getKeepLearningReason = (state: SubscriptionCancelStore): SubscriptionCancelStore['keepLearningReason'] => state.keepLearningReason
export const keepLearningReasons = {
  isKeepLearningReason: (state: SubscriptionCancelStore): boolean => !!state.keepLearningReason,
  getKeepLearningReason: (state: SubscriptionCancelStore): SubscriptionCancelStore['keepLearningReason'] => getKeepLearningReason(state),
  isDecreasePace: (state: SubscriptionCancelStore): boolean => state.keepLearningReason === KeepLearningReason.DecreasePace,
  isDiscount: (state: SubscriptionCancelStore): boolean => state.keepLearningReason === KeepLearningReason.Discount,
}
